import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

function Internal_Audit_table({ onEdit }) {
  const data = [
    {
      srNo: 101,
      documentName: "Document Name 1",
      startDate: "10 JAN 2025",
      endDate: "13 FEB 2025",
      remark: "---",
      status: "Pending",
    },
  ];

  const getStatusClass = (status) => {
    switch (status) {
      case "Pending":
        return "red";
      default:
        return "";
    }
  };
  
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <section className="Imperiality_table">
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped customer_table">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Document Name</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Attached File</th>
                <th>Remarks</th>
                <th>Status</th>
                <th>Corrective Action</th>
              </tr>
            </thead>

            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  <td>{row.srNo}</td>
                  <td>{row.documentName}</td>
                  <td>{row.startDate}</td>
                  <td>{row.endDate}</td>

                  <td className="file_actions">
                    <span className="download_link">Download File</span>
                    <span className="view_link">View</span>
                  </td>

                  <td>{row.remark}</td>
                  <td className={`status ${getStatusClass(row.status)}`}>
                    {row.status}
                  </td>

                  <td>
                    <div className="action_icons">
                      <FontAwesomeIcon
                        icon={faPen}
                        onClick={onEdit}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </section>
  );
}

export default Internal_Audit_table;
